import { memo, useState } from 'react';
import { Link } from '@mui/material';

const productList = [
  { text: 'Launchpad', url: 'https://launchpad.embernetwork.io' },
  { text: 'Staking', url: 'https://staking.embernetwork.io/' },
  { text: 'Agency', url: 'https://agency.embernetwork.io/' },
];

const helpList = [
  {
    text: 'Apply to Launch',
    url: 'https://docs.google.com/forms/d/1K_GPDM6RmYbz60GWyEy9IKXUyEGBrRqlTnmqU8Gd1cw/viewform?edit_requested=true#settings',
  },
  {
    text: 'Contact us',
    url: 'mailto:customersupport@embernetwork.io',
    className: 'text-white px-3 py-1 rounded border border-solid border-white hover:border-[#C685F9]',
  },
];

const mediaList = [
  { image: 'teleglobal', url: 'https://t.me/EmberNetwork_Group' },
  { image: 'teleglobal', url: 'https://t.me/EmberNetwork' },
  { image: 'linkedin', url: 'https://www.linkedin.com/company/ember-network' },
];

const Title = ({ text }) => <div className='text-white text-xl font-semibold mb-7'>{text}</div>;

const CustomText = ({ text, className }) => (
  <div className={`${className || ''} text-[#A2A8B3] hover:text-[#C685F9]`}>{text}</div>
);

const HoverLogoMedia = ({ image }) => {
  const [color, setColor] = useState('inactive');

  return (
    <div
      className='cursor-pointer w-fit'
      onMouseEnter={() => setColor('active')}
      onMouseLeave={() => setColor('inactive')}
    >
      <img className='block w-6 h-6' src={`/assets/imgs/socials/${image}-${color}.png`} alt='' />
    </div>
  );
};

const Footer = memo(() => (
  <div className='px-4 py-10 bg-[#141416] flex justify-center' style={{ borderTop: '1px solid #2F3033' }}>
    <div className='max-w-[1320px] w-full text-[#667085]'>
      <div className='grid grid-cols-2 md:grid-cols-5 gap-10 pb-8 mb-8 border-solid border-b-[1px] border-[#2F3033]'>
        <div className='col-span-2 border-solid border-b-[1px] md:border-b-0 md:border-r-[1px] border-[#2F3033] pb-8'>
          <Link href='/'>
            <img
              src={require('assets/icons/logo-ember-invert-transparent.png')}
              className='h-10 mb-[18px]'
              alt='Ember logo'
            />
          </Link>
          <div className='pr-10 text-[#A2A8B3]'>
            Ember Network is the leading multi-chain launchpad for IDOs and INOs of up-and-coming high quality web3
            projects, in which users can seamlessly participate and support the project!
          </div>
        </div>
        <div>
          <Title text='Product' />
          <div className='flex flex-col gap-2'>
            {productList.map((item, index) => (
              <div key={index} className='flex'>
                <Link href={item.url} target='_blank'>
                  <CustomText text={item.text} />
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div>
          <Title text='Help Center' />
          <div className='flex flex-col gap-2'>
            {helpList.map((item, index) => (
              <div key={index} className='flex'>
                <Link href={item.url} target='_blank'>
                  <CustomText className={item.className} text={item.text} />
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div>
          <Title text='Contact' />
          <div className='grid grid-cols-3 gap-6 max-w-[117px]'>
            {mediaList.map((item, index) => (
              <div key={index}>
                <Link href={item.url} target='_blank'>
                  <HoverLogoMedia image={item.image} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className='flex justify-end text-sm break-words'>customersupport@embernetwork.io</div>
    </div>
  </div>
));

export default Footer;
